import styles from './template.css';
import template from './template';
import {AoflElement, customElement} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {isMobile} from '@aoflmkt/is-mobile';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {accessibilityMixin} from '../../../../../modules/accessibility-mixin';
import {clickTrackerMixin} from '../../../../../modules/click-tracker-mixin';
import {sdoNamespaces} from '../../../../../modules/constants-enumerate';
import {ModalService} from '../../../../../modules/modal-service';
import {modalsConfig} from '../../__config/modals';
import './modules/sdo';

const Mixin = mapStatePropertiesMixin(clickTrackerMixin(accessibilityMixin(AoflElement)));

/**
 * @summary Carousel
 * @extends {AoflElement}
 */
@customElement('carousel-element')
class Carousel extends Mixin {
  /**
   * Creates an instance of Carousel.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
    ModalService.addModals(modalsConfig);
    this.clearAnimationStyles();
    this.freezeArrow = false;
  }

  /**
   *
   * @private
   * @readonly
   */
  static get properties() {
    return {
      image0: {type: String, attr: false},
      image1: {type: String, attr: false},
      image2: {type: String, attr: false},
      image3: {type: String, attr: false},
      image4: {type: String, attr: false},
      image5: {type: String, attr: false},
      currentImage: {type: String, attr: false},
      screen0Animation: {type: String, attr: false},
      screen1Animation: {type: String, attr: false},
      screen2Animation: {type: String, attr: false},
      screen3Animation: {type: String, attr: false},
      screen4Animation: {type: String, attr: false},
      screen5Animation: {type: String, attr: false}
    };
  }

  /**
   *
   */
  right(e) {
    e.preventDefault();
    if (this.freezeArrow) {
      return;
    }
    this.freezeArrow = true;
    this.clearAnimationStyles();

    this.screen0Animation = 'fadeOutLeft';
    this.screen1Animation = 'slideInRight';
    this.screen2Animation = 'slideInRight';
    this.screen3Animation = 'slideInRight';
    if (isMobile.any) {
      this.screen4Animation = 'fadeInRight';
    } else {
      this.screen4Animation = 'slideInRight';
      this.screen5Animation = 'fadeInRight';
    }

    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'increasePosition0'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'increasePosition1'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'increasePosition2'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'increasePosition3'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'increasePosition4'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'increasePosition5'
    });

    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideRightImage0'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideRightImage1'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideRightImage2'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideRightImage3'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideRightImage4'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideRightImage5'
    });

    setTimeout(() => {
      this.clearAnimationStyles();
      this.freezeArrow = false;
    }, 600);
  }

  /**
   *
   */
  left(e) {
    e.preventDefault();
    if (this.freezeArrow) {
      return;
    }
    this.freezeArrow = true;
    this.clearAnimationStyles();

    this.screen0Animation = 'fadeInLeft';
    this.screen1Animation = 'slideInLeft';
    this.screen2Animation = 'slideInLeft';
    this.screen3Animation = 'slideInLeft';
    this.screen4Animation = 'slideInLeft';
    this.screen5Animation = 'fadeOutRightScreen5';

    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'decreasePosition0'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'decreasePosition1'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'decreasePosition2'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'decreasePosition3'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'decreasePosition4'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'decreasePosition5'
    });

    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideLeftImage0'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideLeftImage1'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideLeftImage2'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideLeftImage3'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideLeftImage4'
    });
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'slideLeftImage5'
    });

    setTimeout(() => {
      this.clearAnimationStyles();
      this.freezeArrow = false;
    }, 600);
  }

  /**
   *
   */
  updateCurrentImage(e) {
    e.preventDefault();
    const src = e.target.src;
    const position = e.target.id;
    this.storeInstance.commit({
      namespace: sdoNamespaces.HOME_CAROUSEL,
      mutationId: 'updateCurrentImage',
      payload: {src, position}
    });
  }

  /**
   *
   */
  clearAnimationStyles() {
    this.screen0Animation = '';
    this.screen1Animation = '';
    this.screen2Animation = '';
    this.screen3Animation = '';
    this.screen4Animation = '';
    this.screen5Animation = '';
  }

  /**
   *
   */
  showCarouselModal(e) {
    e.preventDefault();
    if (!isMobile.any) {
      ModalService.show('carouselModal');
    }
  }

  /**
   * @readonly
   */
  static get is() {
    return 'carousel-element';
  }

  /**
   *
   */
  mapStateProperties() {
    const state = this.storeInstance.getState();
    this.image0 = state[sdoNamespaces.HOME_CAROUSEL].image0;
    this.image1 = state[sdoNamespaces.HOME_CAROUSEL].image1;
    this.image2 = state[sdoNamespaces.HOME_CAROUSEL].image2;
    this.image3 = state[sdoNamespaces.HOME_CAROUSEL].image3;
    this.image4 = state[sdoNamespaces.HOME_CAROUSEL].image4;
    this.image5 = state[sdoNamespaces.HOME_CAROUSEL].image5;
    this.position0 = state[sdoNamespaces.HOME_CAROUSEL].position0;
    this.position1 = state[sdoNamespaces.HOME_CAROUSEL].position1;
    this.position2 = state[sdoNamespaces.HOME_CAROUSEL].position2;
    this.position3 = state[sdoNamespaces.HOME_CAROUSEL].position3;
    this.position4 = state[sdoNamespaces.HOME_CAROUSEL].position4;
    this.position5 = state[sdoNamespaces.HOME_CAROUSEL].position5;
    this.currentImage = state[sdoNamespaces.HOME_CAROUSEL].currentImage;
    this.currentImagePosition = state[sdoNamespaces.HOME_CAROUSEL].currentImagePosition;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default Carousel;
